export default __webpack_public_path__ + "assets/images/5d80352a220de63d4aa64f35eeba3787.svg";